import { useSyncExternalStore } from 'react';

/**
 * La liste de l'Aide est-elle ouverte au-dessus de l'ampoule (ticket 11 de retours-testeurs) ?
 *
 * Un seul état pour tout l'écran : l'ampoule l'ouvre et la referme, et le tuto la rouvre à la
 * fin d'une partie (« Retour à l'Aide ») ou quand on la quitte. Rien n'est gardé au-delà de la
 * page : c'est ce qu'on regarde, pas une donnée.
 */

let ouverte = false;
const abonnes = new Set<() => void>();

export function ouvrirLAide(voulu: boolean): void {
  if (voulu === ouverte) return;
  ouverte = voulu;
  for (const abonne of abonnes) abonne();
}

function sAbonner(abonne: () => void) {
  abonnes.add(abonne);
  return () => abonnes.delete(abonne);
}

export function useAideOuverte(): boolean {
  return useSyncExternalStore(sAbonner, () => ouverte);
}
